import axios from "axios"
import { LOCAL_TOKEN } from "../utils/storage"

export const deleteAmbassadorApi = (params) => {
  const url = `ambassadors/${params.id_ambassador}/${
    params.id_division ? params.id_division : ""
  }`
  return axios.request({
    method: "DELETE",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL + url}`,
  })
}

export const createAmbassadorApi = (params) => {
  const url = "ambassadors"
  const method = "POST"
  return axios.request({
    method,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: params,
    url: `${process.env.API_URL + url}`,
  })
}
